(() => {
  function init(root = document) {
    root.querySelectorAll('[data-ind-country]').forEach(country => {
      if (country.dataset.ready) return;
      country.dataset.ready = 'true';
      const province = country.closest('form').querySelector('[data-ind-province]');
      if (country.dataset.selected) country.value = country.dataset.selected;
      function refreshProvinces() {
        let options = [];
        try { options = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]'); } catch {}
        province.replaceChildren(...options.map(([value, label]) => new Option(label, value)));
        province.closest('label').hidden = options.length === 0;
        province.disabled = options.length === 0;
      }
      refreshProvinces();
      if (province.dataset.selected) province.value = province.dataset.selected;
      country.addEventListener('change', refreshProvinces);
    });
    root.querySelectorAll('[data-ind-print]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => window.print());
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const arrowPaths = {
    '→': 'M4 12h16m-6-6 6 6-6 6',
    '←': 'M20 12H4m6-6-6 6 6 6',
    '↑': 'M12 20V4M6 10l6-6 6 6',
    '↓': 'M12 4v16M6 14l6 6 6-6',
    '↗': 'M5 19 19 5M6 5h13v13',
    '↘': 'M5 5l14 14M6 19h13V6',
    '↖': 'M19 19 5 5m13 0H5v13',
    '↙': 'M19 5 5 19m13 0H5V6'
  };
  const arrowPattern = /[→←↑↓↗↘↖↙]\uFE0F?/g;
  const arrowContext = 'a,button,summary,[aria-hidden="true"],.vp-announcement';
  const skipContext = 'script,style,textarea,select,input,svg,code,pre,[contenteditable="true"],[data-atelier-arrow]';
  function createArrow(symbol) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('data-atelier-arrow', symbol);
    svg.setAttribute('style', 'display:inline-block;width:1em;height:1em;min-width:1em;flex:none;vertical-align:-.12em;overflow:visible;pointer-events:none');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', arrowPaths[symbol]);
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.65');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    return svg;
  }
  function replaceArrowText(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(skipContext) || !parent.closest(arrowContext)) return;
    const text = node.nodeValue;
    arrowPattern.lastIndex = 0;
    const matches = [...text.matchAll(arrowPattern)];
    if (!matches.length) return;
    const control = parent.closest('a,button,summary');
    if (control && !control.hasAttribute('aria-label') && !control.hasAttribute('aria-labelledby') && !control.textContent.replace(arrowPattern, '').trim()) return;
    const fragment = document.createDocumentFragment();
    let cursor = 0;
    for (const match of matches) {
      fragment.append(document.createTextNode(text.slice(cursor, match.index)), createArrow(match[0][0]));
      cursor = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(text.slice(cursor)));
    node.replaceWith(fragment);
  }
  function upgradeArrows(root) {
    if (root.nodeType === Node.TEXT_NODE) { replaceArrowText(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(skipContext)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(replaceArrowText);
  }
  function watchArrows() {
    upgradeArrows(document.body);
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') upgradeArrows(record.target);
        else record.addedNodes.forEach(upgradeArrows);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchArrows, { once: true });
  else watchArrows();
})();

(() => {
  function improveSupportAndPurchaseLinks() {
    const link = document.querySelector('a.ind-whatsapp[href^="https://wa.me/"]');
    if (link && !link.querySelector('[data-lop-whatsapp-icon]')) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '22');
      svg.setAttribute('height', '22');
      svg.setAttribute('fill', 'currentColor');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('data-lop-whatsapp-icon', '');
      svg.style.cssText = 'width:22px;height:22px;flex:none;vertical-align:middle;margin-right:8px';
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', 'M20.52 3.48A11.91 11.91 0 0 0 12.04 0C5.45 0 .09 5.36.09 11.95c0 2.1.55 4.16 1.6 5.98L0 24l6.23-1.63a11.94 11.94 0 0 0 5.8 1.48h.01C18.63 23.85 24 18.49 24 11.9c0-3.19-1.24-6.18-3.48-8.42ZM12.04 21.83h-.01a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.7.97.99-3.61-.24-.37a9.9 9.9 0 0 1-1.52-5.28c0-5.48 4.46-9.94 9.95-9.94a9.87 9.87 0 0 1 7.03 2.91 9.87 9.87 0 0 1 2.91 7.03c0 5.48-4.47 9.88-10.01 9.88Zm5.45-7.44c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.94 1.17-.18.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.67-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.49 1.71.63.72.23 1.37.2 1.88.12.58-.09 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z');
      svg.append(path);
      link.prepend(svg);
      link.style.display = 'inline-flex';
      link.style.alignItems = 'center';
      link.style.minHeight = '44px';
    }
    if (document.getElementById('vpp-buy')) {
      const labels = new Set(['Je choisis le maintien 360°', 'Je commande en confiance']);
      document.querySelectorAll('a[href="#"]').forEach(anchor => {
        if (labels.has(anchor.textContent.trim())) anchor.setAttribute('href', '#vpp-buy');
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', improveSupportAndPurchaseLinks, { once: true });
  else improveSupportAndPurchaseLinks();
  document.addEventListener('shopify:section:load', improveSupportAndPurchaseLinks);
})();
